// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3H-we","fileBtn":"File_fileBtn__17ksm","closeBtn":"File_closeBtn__2Uv46","fileSelected":"File_fileSelected__2jbZs","disabled":"File_disabled__ugIDs"};